import { CSSProgressiveBody03Medium } from "@caisy/league";
import styled from "styled-components";

export const SActiveUsersDropdownItemName = styled.h2`
  ${CSSProgressiveBody03Medium};
  color: var(--text-01);
`;
